import { useState } from 'react';
import { CustomDialogProps } from '@/dashboard/components/Dialog/index';
import PolicyModel from '@/dashboard/models/policys/PolicyModel';
import { usePolicyStore } from '@/dashboard/store/PolicyStore';
import { PROVIDER_SOURCE } from '@jove-frontend/uikit';
import AlertInfoView from './alertInfo';
import CancelConfirmView from './confirm';
import FormEditView from './form';
import CancelSuccessView from './success';

type CancelPolicyDialogViewProps = CustomDialogProps & {
  policy: PolicyModel;
};
const CancelPolicyDialog = (props: CancelPolicyDialogViewProps) => {
  const { close, policy } = props;
  const [step, setStep] = useState([PROVIDER_SOURCE().RECRUITMENT.value, PROVIDER_SOURCE().ACCELERANT.value].includes(policy?.providerCode) ? 2 : 1);
  const [submitInfo, setSubmitInfo] = useState();
  const {
    actions: { fetchPolicies },
  } = usePolicyStore();

  /**
   * methods
   */
  const confirmFormAction = (info) => {
    setSubmitInfo(info);
    setStep(3);
  };

  // confirm click back
  const confirmBackAction = () => {
    setStep(2);
  };

  // cancel success
  const cancelSuccessAction = () => {
    setStep(4);
  };

  const closeCancelPolicySuccessAction = () => {
    fetchPolicies();
    close?.();
  };

  return (
    <>
      {step === 1 && <AlertInfoView close={close} continueCancel={() => setStep(2)} />}
      {step === 2 && (
        <FormEditView
          policy={policy}
          close={close}
          confirm={confirmFormAction}
          submitInfo={submitInfo}
          cancelSuccess={closeCancelPolicySuccessAction}
        />
      )}
      {step === 3 && (
        <CancelConfirmView policy={policy} close={close} back={confirmBackAction} success={cancelSuccessAction} submitInfo={submitInfo} />
      )}
      {step === 4 && <CancelSuccessView close={closeCancelPolicySuccessAction} submitInfo={submitInfo} />}
    </>
  );
};

export default CancelPolicyDialog;
